<template>
  <el-dialog title="图片裁切" :visible="visible" @close="off" width="705px">
    <div class="vue-image-crop-upload">
      <div class="vicp-wrap">
        <div class="vicp-step1" v-show="step === 1">
          <label class="description">{{description}}</label>
          <div class="vicp-drop-area" @dragleave="preventDefault" @dragover="preventDefault" @dragenter="preventDefault"
            @click="handleClick" @drop="handleChange">
            <i class="vicp-icon1" v-show="loading !== 1">
              <i class="vicp-icon1-arrow"></i>
              <i class="vicp-icon1-body"></i>
              <i class="vicp-icon1-bottom"></i>
            </i>
            <span class="vicp-hint" v-show="loading !== 1">{{ lang.hint }}</span>
            <span class="vicp-no-supported-hint" v-show="!isSupported">{{ lang.noSupported }}</span>
            <input type="file" v-show="false" v-if="step === 1" @change="handleChange" ref="fileinput">
          </div>
          <div class="vicp-error" v-show="hasError">
            <!-- <i class="vicp-icon2"></i> {{ errorMsg }} -->
            <el-alert style="margin-top:10px" type="error" :title="errorMsg" :closable="false" show-icon>
            </el-alert>
          </div>
        </div>
        <div class="vicp-step2" v-if="step === 2">
          <div class="vicp-crop">
            <div class="vicp-crop-left" v-show="true">
              <div class="vicp-img-title">{{ lang.editor }}</div>
              <div class="vicp-img-container">
                <img :src="sourceImgUrl" :style="sourceImgStyle" class="vicp-img" draggable="false"
                  @drag="preventDefault" @dragstart="preventDefault" @dragend="preventDefault"
                  @dragleave="preventDefault" @dragover="preventDefault" @dragenter="preventDefault"
                  @drop="preventDefault" @touchstart="imgStartMove" @touchmove="imgMove" @touchend="createImg"
                  @touchcancel="createImg" @mousedown="imgStartMove" @mousemove="imgMove" @mouseup="createImg"
                  @mouseout="createImg" ref="img">
                <div class="vicp-img-shade vicp-img-shade-1" :style="sourceImgShadeStyle"></div>
                <div class="vicp-img-shade vicp-img-shade-2" :style="sourceImgShadeStyle"></div>
                <div class="vicp-rotate" @click="rotateImg" v-if="!noRotate" :title="rotateBtnTitle">
                  <i :style="rotateBtnStyle">↻</i>
                </div>
              </div>
              <div class="vicp-range">
                <input type="range" :value="scale.range" step="1" min="0" max="1000" @mousemove="zoomChange">
                <i @mousedown="startZoomSub" @mouseout="endZoomSub" @mouseup="endZoomSub" class="vicp-icon5"
                  :title="lang.zoomOut"></i>
                <i @mousedown="startZoomAdd" @mouseout="endZoomAdd" @mouseup="endZoomAdd" class="vicp-icon6"
                  :title="lang.zoomIn"></i>
              </div>
            </div>
            <div class="vicp-crop-right" v-show="true">
              <div class="vicp-preview">
                <div class="vicp-preview-title">{{ lang.preview }}</div>
                <div class="vicp-preview-item i1">
                  <div class="vicp-preview-img" :style="previewStyle.origin">
                    <img :src="createImgUrl" :style="previewStyle.origin">
                  </div>
                </div>
                <div class="vicp-preview-item i3">
                  <div class="vicp-preview-img" :style="previewStyle.circle">
                    <img :src="createImgUrl" :style="{width:'100%'}">
                  </div>
                </div>
                <div class="vicp-preview-item i2">
                  <div class="vicp-preview-img" :style="previewStyle.square">
                    <img :src="createImgUrl" :style="{width:'100%'}">
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="vicp-step3" v-if="step === 3">
          <div class="vicp-upload">
            <span class="vicp-loading" v-show="loading === 1">{{ lang.loading }}</span>
            <div class="vicp-progress-wrap">
              <span class="vicp-progress" v-show="loading === 1" :style="progressStyle"></span>
            </div>
            <div class="vicp-error" v-show="hasError">
              <i class="vicp-icon2"></i> {{ errorMsg }}
            </div>
            <div class="vicp-success" v-show="loading === 2">
              <i class="vicp-icon3"></i> {{ lang.success }}
            </div>
          </div>
        </div>
        <canvas v-show="false" :width="width" :height="height" ref="canvas"></canvas>
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <template v-if="step === 1">
        <el-button type="primary" @click="off">{{ lang.btn.off }}</el-button>
      </template>
      <template v-if="step === 2">
        <el-button type="defalt" @click="setStep(1)">{{ lang.btn.back }}</el-button>
        <el-button type="primary" class="vicp-operate-btn" @click="prepareUpload">{{ lang.btn.save }}</el-button>
      </template>
      <template v-if="step === 3">
        <!-- <el-button type="defalt" @click="setStep(2)">{{ lang.btn.back }}</el-button> -->
        <el-button type="primary" @click="off">{{ lang.btn.close }}</el-button>
      </template>
    </div>
  </el-dialog>
</template>

<script>
const language = {
  zh: {
    hint: '点击选择图片或把图片拖至此处',
    loading: '正在上传…',
    noSupported: '浏览器不支持该功能，请使用IE10以上或其他现代浏览器',
    success: '上传成功',
    fail: '上传失败',
    editor: '编辑',
    preview: '预览',
    rotate: '顺时针旋转90度',
    zoomIn: '放大',
    zoomOut: '缩小',
    btn: {
      off: '取消',
      close: '关闭',
      back: '上一步',
      save: '确定'
    },
    error: {
      onlyImg: '仅限图片格式',
      outOfSize: '单文件大小不能超过 ',
      lowestPx: '图片最低像素为（宽*高）：',
      fileError: '图片读取失败，请刷新页面再试'
    }
  }
};

const mimes = {
  jpg: 'image/jpeg',
  png: 'image/png',
  gif: 'image/gif',
  svg: 'image/svg+xml',
  psd: 'image/photoshop'
};

/**
 * database64文件格式转换为2进制
 *
 * @param  {[String]} data dataURL 的格式为 “data:image/png;base64,****”,逗号之前都是一些说明性的文字，我们只需要逗号之后的就行了
 * @param  {[String]} mime [description]
 * @return {[blob]}      [description]
 */
const data2blob = function(data, mime) {
  data = data.split(',')[1];
  data = window.atob(data);
  var ia = new Uint8Array(data.length);
  for (var i = 0; i < data.length; i++) {
    ia[i] = data.charCodeAt(i);
  }
  // canvas.toDataURL 返回的默认格式就是 image/png
  return new Blob([ia], {
    type: mime
  });
};

export default {
  props: {
    // 域，上传文件name，触发事件会带上（如果一个页面多个图片上传控件，可以做区分
    field: {
      type: String,
      default: 'avatar'
    },
    // 原名key，类似于id，触发事件会带上（如果一个页面多个图片上传控件，可以做区分
    ki: {
      default: 0
    },
    // 显示该控件与否
    visible: {
      default: true
    },
    // 上传地址
    url: {
      type: String,
      default: ''
    },
    // 其他要上传文件附带的数据，对象格式
    params: {
      type: Object,
      default: null
    },
    // Add custom headers
    headers: {
      type: Object,
      default: null
    },
    // 剪裁图片的宽
    width: {
      type: Number,
      default: 200
    },
    // 剪裁图片的高
    height: {
      type: Number,
      default: 200
    },
    // 不显示旋转功能
    noRotate: {
      type: Boolean,
      default: false
    },
    // 单文件大小限制
    maxSize: {
      type: Number,
      default: 10240
    },
    // 语言类型
    langType: {
      type: String,
      default: 'zh'
    },
    // 语言包
    langExt: {
      type: Object,
      default: null
    },
    // 图片上传格式
    imgFormat: {
      type: String,
      default: 'png'
    },
    // 图片背景 jpg情况下生效
    imgBgc: {
      type: String,
      default: '#fff'
    },
    // 是否支持跨域
    withCredentials: {
      type: Boolean,
      default: false
    },
    method: {
      type: String,
      default: 'POST'
    }
  },
  data() {
    let that = this;
    let { imgFormat, langType, langExt, width, height } = that;
    let isSupported = true;
    let allowImgFormat = ['jpg', 'png'];
    let tempImgFormat =
      allowImgFormat.indexOf(imgFormat) === -1 ? 'jpg' : imgFormat;
    let lang = language[langType] ? language[langType] : language['en'];
    let mime = mimes[tempImgFormat];
    // 规范图片格式
    that.imgFormat = tempImgFormat;

    if (langExt) {
      Object.assign(lang, langExt);
    }
    if (typeof FormData !== 'function') {
      isSupported = false;
    }
    return {
      // 描述/提示信息
      description: `请上传图片格式文件。图片像素需${this.width}*${
        this.height
      }以上，且文件大小不得超过${(this.maxSize / 1024).toFixed(1)}M。`,
      // 图片的mime
      mime,
      // 语言包
      lang,
      // 浏览器是否支持该控件
      isSupported,
      // 浏览器是否支持触屏事件
      isSupportTouch: document.hasOwnProperty('ontouchstart'),
      // 步骤
      step: 1, // 1选择文件 2剪裁 3上传
      // 上传状态及进度
      loading: 0, // 0未开始 1正在 2成功 3错误
      progress: 0,
      // 是否有错误及错误信息
      hasError: false,
      errorMsg: '',
      // 需求图宽高比
      ratio: width / height,
      rotatable: true, // 旋转后将会不合格的图片禁用旋转功能
      // 原图地址、生成图片地址
      sourceImg: null,
      sourceImgUrl: '',
      createImgUrl: '',
      // 原图片拖动事件初始值
      sourceImgMouseDown: {
        on: false,
        mX: 0, // 鼠标按下的坐标
        mY: 0,
        x: 0, // scale原图坐标
        y: 0
      },
      // 生成图片预览的容器大小
      previewContainer: {
        width: 100,
        height: 100
      },
      // 原图容器宽高
      sourceImgContainer: {
        // sic
        width: 320,
        height: 240 // 如果生成图比例与此一致会出现bug（搬来之人注：原作者这样写的，原因未找到）
      },
      // 原图展示属性
      scale: {
        zoomAddOn: false, // 按钮缩放事件开启
        zoomSubOn: false, // 按钮缩放事件开启
        range: 1, // 最大100
        x: 0,
        y: 0,
        width: 0,
        height: 0,
        maxWidth: 0,
        maxHeight: 0,
        minWidth: 0, // 最宽
        minHeight: 0,
        naturalWidth: 0, // 原宽
        naturalHeight: 0
      }
    };
  },
  computed: {
    rotateBtnTitle() {
      let {
        width,
        height,
        scale: { naturalWidth, naturalHeight }
      } = this;
      return this.rotatable
        ? this.lang.rotate
        : `不可旋转（旋转后的尺寸 ${naturalHeight}*${naturalWidth} 小于标准 ${width}*${height}）`;
    },
    rotateBtnStyle() {
      return this.rotatable ? {} : { backgroundColor: '#c7c7c7' };
    },
    // 进度条样式
    progressStyle() {
      let { progress } = this;
      return {
        width: progress + '%'
      };
    },
    // 原图样式
    sourceImgStyle() {
      let { scale, sourceImgMasking } = this;
      let top = scale.y + sourceImgMasking.y + 'px';
      let left = scale.x + sourceImgMasking.x + 'px';
      return {
        top,
        left,
        width: scale.width + 'px',
        height: scale.height + 'px' // 兼容 Opera
      };
    },
    // 原图蒙版属性
    sourceImgMasking() {
      let { width, height, ratio, sourceImgContainer } = this;
      let sic = sourceImgContainer;
      let sicRatio = sic.width / sic.height; // 原图容器宽高比
      let x = 0;
      let y = 0;
      let w = sic.width;
      let h = sic.height;
      let scale = 1;
      if (ratio < sicRatio) {
        scale = sic.height / height;
        w = sic.height * ratio;
        x = (sic.width - w) / 2;
      }
      if (ratio > sicRatio) {
        scale = sic.width / width;
        h = sic.width / ratio;
        y = (sic.height - h) / 2;
      }
      return {
        scale, // 蒙版相对需求宽高的缩放
        x,
        y,
        width: w,
        height: h
      };
    },
    // 原图遮罩样式
    sourceImgShadeStyle() {
      let { sourceImgMasking, sourceImgContainer } = this;
      let sic = sourceImgContainer;
      let sim = sourceImgMasking;
      let w = sim.width === sic.width ? sim.width : (sic.width - sim.width) / 2;
      let h =
        sim.height === sic.height ? sim.height : (sic.height - sim.height) / 2;
      return {
        width: w + 'px',
        height: h + 'px'
      };
    },
    previewStyle() {
      let { width, height, sourceImgContainer } = this;
      let h = sourceImgContainer.height;
      let w = (sourceImgContainer.height * width) / height;
      let h4circle = (h - 20) / 2;
      return {
        origin: {
          width: w + 'px',
          height: h + 'px'
        },
        circle: {
          'border-radius': '100%',
          'margin-bottom': '20px',
          width: h4circle + 'px',
          height: h4circle + 'px'
        },
        square: {
          width: h4circle + 'px',
          height: h4circle + 'px'
        }
      };
    }
  },
  watch: {
    visible(newValue) {
      if (newValue && this.loading !== 1) {
        this.reset();
      }
    }
  },
  methods: {
    // 关闭控件
    off() {
      if (this.step === 3 && this.loading === 2) {
        this.setStep(1);
      }
      this.$emit('update:visible', false);
    },
    // 设置步骤
    setStep(no) {
      // 延时是为了显示动画效果呢，哈哈哈
      setTimeout(() => {
        this.step = no;
      }, 200);
    },

    // 图片选择区域函数绑定
    preventDefault(e) {
      e.preventDefault();
      return false;
    },
    handleClick(e) {
      if (this.loading !== 1) {
        if (e.target !== this.$refs.fileinput) {
          e.preventDefault();
          if (document.activeElement !== this.$refs) {
            this.$refs.fileinput.click();
          }
        }
      }
    },
    handleChange(e) {
      e.preventDefault();
      if (this.loading !== 1) {
        let files = e.target.files || e.dataTransfer.files;
        this.reset();
        if (this.checkFile(files[0])) {
          this.setSourceImg(files[0]);
        }
      }
    },

    // 检测选择的文件是否合适
    checkFile(file) {
      let that = this;
      let { lang, maxSize } = that;

      // 文件读取失败
      if (!file) {
        that.hasError = true;
        that.errorMsg = lang.error.fileError;
        return false;
      }

      // 仅限图片
      if (file.type.indexOf('image') === -1) {
        that.hasError = true;
        that.errorMsg = lang.error.onlyImg;
        return false;
      }

      // 超出大小
      if (file.size / 1024 > maxSize) {
        that.hasError = true;
        that.errorMsg = lang.error.outOfSize + maxSize + 'kb';
        return false;
      }
      return true;
    },
    // 重置控件
    reset() {
      let that = this;
      that.loading = 0;
      that.hasError = false;
      that.errorMsg = '';
      that.progress = 0;
    },
    // 设置图片源
    setSourceImg(file) {
      this.$emit('src-file-set', file.name, file.type, file.size);
      let that = this;
      let fr = new FileReader();
      fr.onload = function(e) {
        that.sourceImgUrl = fr.result;
        that.startCrop();
      };
      fr.readAsDataURL(file);
    },
    // 剪裁前准备工作
    startCrop() {
      let that = this;
      let {
        width,
        height,
        ratio,
        scale,
        sourceImgUrl,
        sourceImgMasking,
        lang
      } = that;
      let sim = sourceImgMasking;
      let img = new Image();
      img.src = sourceImgUrl;
      img.onload = function() {
        let nWidth = img.naturalWidth;
        let nHeight = img.naturalHeight;
        let nRatio = nWidth / nHeight;
        let w = sim.width;
        let h = sim.height;
        let x = 0;
        let y = 0;
        // 旋转后尺寸不符合的图片会导致BUG(自动放大图片因为改动太大放弃了)
        if (Math.min(nWidth, nHeight) < Math.max(width, height)) {
          that.rotatable = false;
        } else {
          that.rotatable = true;
        }
        // 图片像素不达标
        if (nWidth < width || nHeight < height) {
          that.hasError = true;
          that.errorMsg = lang.error.lowestPx + width + '*' + height;
          return false;
        }
        if (ratio > nRatio) {
          h = w / nRatio;
          y = (sim.height - h) / 2;
        }
        if (ratio < nRatio) {
          w = h * nRatio;
          x = (sim.width - w) / 2;
        }
        scale.range = 0;
        scale.x = x;
        scale.y = y;
        scale.width = w;
        scale.height = h;
        scale.minWidth = w;
        scale.minHeight = h;
        scale.maxWidth = nWidth * sim.scale;
        scale.maxHeight = nHeight * sim.scale;
        scale.naturalWidth = nWidth;
        scale.naturalHeight = nHeight;
        that.sourceImg = img;
        that.createImg();
        that.setStep(2);
      };
    },
    // 鼠标按下图片准备移动
    imgStartMove(e) {
      e.preventDefault();
      // 支持触摸事件，则鼠标事件无效
      if (this.isSupportTouch && !e.targetTouches) {
        return false;
      }
      let et = e.targetTouches ? e.targetTouches[0] : e;
      let { sourceImgMouseDown, scale } = this;
      let simd = sourceImgMouseDown;
      simd.mX = et.screenX;
      simd.mY = et.screenY;
      simd.x = scale.x;
      simd.y = scale.y;
      simd.on = true;
    },
    // 鼠标按下状态下移动，图片移动
    imgMove(e) {
      e.preventDefault();
      // 支持触摸事件，则鼠标事件无效
      if (this.isSupportTouch && !e.targetTouches) {
        return false;
      }
      let et = e.targetTouches ? e.targetTouches[0] : e;
      let {
        sourceImgMouseDown: { on, mX, mY, x, y },
        scale,
        sourceImgMasking
      } = this;
      let sim = sourceImgMasking;
      let nX = et.screenX;
      let nY = et.screenY;
      let dX = nX - mX;
      let dY = nY - mY;
      let rX = x + dX;
      let rY = y + dY;
      if (!on) return;
      if (rX > 0) {
        rX = 0;
      }
      if (rY > 0) {
        rY = 0;
      }
      if (rX < sim.width - scale.width) {
        rX = sim.width - scale.width;
      }
      if (rY < sim.height - scale.height) {
        rY = sim.height - scale.height;
      }
      scale.x = rX;
      scale.y = rY;
    },
    // 顺时针旋转图片
    rotateImg(e) {
      let {
        sourceImg,
        scale: { naturalWidth, naturalHeight }
      } = this;
      let width = naturalHeight;
      let height = naturalWidth;
      let canvas = this.$refs.canvas;
      let ctx = canvas.getContext('2d');

      if (!this.rotatable) {
        return false;
      }

      canvas.width = width;
      canvas.height = height;
      ctx.clearRect(0, 0, width, height);

      ctx.fillStyle = 'rgba(0,0,0,0)';
      ctx.fillRect(0, 0, width, height);

      ctx.translate(width, 0);
      ctx.rotate((Math.PI * 90) / 180);

      ctx.drawImage(sourceImg, 0, 0, naturalWidth, naturalHeight);
      let imgUrl = canvas.toDataURL(mimes['png']);

      this.sourceImgUrl = imgUrl;
      this.startCrop();
    },

    // 按钮按下开始放大
    startZoomAdd(e) {
      let that = this;
      let { scale } = that;
      scale.zoomAddOn = true;

      function zoom() {
        if (scale.zoomAddOn) {
          let range = scale.range >= 100 ? 100 : ++scale.range;
          that.zoomImg(range);
          setTimeout(function() {
            zoom();
          }, 60);
        }
      }
      zoom();
    },
    // 按钮松开或移开取消放大
    endZoomAdd(e) {
      this.scale.zoomAddOn = false;
    },
    // 按钮按下开始缩小
    startZoomSub(e) {
      let that = this;
      let { scale } = that;
      scale.zoomSubOn = true;

      function zoom() {
        if (scale.zoomSubOn) {
          let range = scale.range <= 0 ? 0 : --scale.range;
          that.zoomImg(range);
          setTimeout(function() {
            zoom();
          }, 60);
        }
      }
      zoom();
    },
    // 按钮松开或移开取消缩小
    endZoomSub(e) {
      let { scale } = this;
      scale.zoomSubOn = false;
    },
    zoomChange(e) {
      this.zoomImg(e.target.value);
    },
    // 缩放原图
    zoomImg(newRange) {
      let that = this;
      let { sourceImgMasking, scale } = this;
      let {
        maxWidth,
        maxHeight,
        minWidth,
        minHeight,
        width,
        height,
        x,
        y
      } = scale;
      let sim = sourceImgMasking;
      // 蒙版宽高
      let sWidth = sim.width;
      let sHeight = sim.height;
      // 新宽高
      let nWidth = minWidth + ((maxWidth - minWidth) * newRange) / 100;
      let nHeight = minHeight + ((maxHeight - minHeight) * newRange) / 100;
      // 新坐标（根据蒙版中心点缩放）
      let nX = sWidth / 2 - (nWidth / width) * (sWidth / 2 - x);
      let nY = sHeight / 2 - (nHeight / height) * (sHeight / 2 - y);

      // 判断新坐标是否超过蒙版限制
      if (nX > 0) {
        nX = 0;
      }
      if (nY > 0) {
        nY = 0;
      }
      if (nX < sWidth - nWidth) {
        nX = sWidth - nWidth;
      }
      if (nY < sHeight - nHeight) {
        nY = sHeight - nHeight;
      }

      // 赋值处理
      scale.x = nX;
      scale.y = nY;
      scale.width = nWidth;
      scale.height = nHeight;
      scale.range = newRange;
      setTimeout(function() {
        if (scale.range === newRange) {
          that.createImg();
        }
      }, 300);
    },
    // 生成需求图片
    createImg(e) {
      let that = this;
      let {
        imgFormat,
        imgBgc,
        mime,
        sourceImg,
        scale: { x, y, width, height },
        sourceImgMasking: { scale }
      } = that;
      let canvas = that.$refs.canvas;
      let ctx = canvas.getContext('2d');
      if (e) {
        // 取消鼠标按下移动状态
        that.sourceImgMouseDown.on = false;
      }
      canvas.width = that.width;
      canvas.height = that.height;
      ctx.clearRect(0, 0, that.width, that.height);

      if (imgFormat === 'png') {
        ctx.fillStyle = 'rgba(0,0,0,0)';
      } else {
        // 如果jpg 为透明区域设置背景，默认白色
        ctx.fillStyle = imgBgc;
      }
      ctx.fillRect(0, 0, that.width, that.height);

      ctx.drawImage(
        sourceImg,
        x / scale,
        y / scale,
        width / scale,
        height / scale
      );
      that.createImgUrl = canvas.toDataURL(mime);
    },
    prepareUpload() {
      let { url, createImgUrl, field, ki } = this;
      this.$emit('crop-success', createImgUrl, field, ki);
      if (typeof url === 'string' && url) {
        this.upload();
      } else {
        this.off();
      }
    },
    // 上传图片
    upload() {
      let that = this;
      let {
        lang,
        imgFormat,
        mime,
        url,
        params,
        headers,
        field,
        ki,
        createImgUrl,
        withCredentials,
        method
      } = this;
      let fmData = new FormData();
      fmData.append(
        field,
        data2blob(createImgUrl, mime),
        field + '.' + imgFormat
      );

      // 添加其他参数
      if (typeof params === 'object' && params) {
        Object.keys(params).forEach(k => {
          fmData.append(k, params[k]);
        });
      }

      // 监听进度回调
      const uploadProgress = function(event) {
        if (event.lengthComputable) {
          that.progress = (100 * Math.round(event.loaded)) / event.total;
        }
      };

      // 上传文件
      that.reset();
      that.loading = 1;
      that.setStep(1);
      new Promise(function(resolve, reject) {
        let client = new XMLHttpRequest();
        client.open(method, url, true);
        client.withCredentials = withCredentials;
        client.onreadystatechange = function() {
          if (this.readyState !== 4) {
            return;
          }
          if (this.status === 200 || this.status === 201) {
            resolve(JSON.parse(this.responseText));
          } else {
            reject(this.status);
          }
        };
        client.upload.addEventListener('progress', uploadProgress, false); // 监听进度
        // 设置header
        if (typeof headers === 'object' && headers) {
          Object.keys(headers).forEach(k => {
            client.setRequestHeader(k, headers[k]);
          });
        }
        client.send(fmData);
      }).then(
        // 上传成功
        function(resData) {
          if (that.visible) {
            that.loading = 2;
            that.$emit('crop-upload-success', resData, field, ki);
          }
        },
        // 上传失败
        function(sts) {
          if (that.visible) {
            that.loading = 3;
            that.hasError = true;
            that.errorMsg = lang.fail;
            that.$emit('crop-upload-fail', sts, field, ki);
          }
        }
      );
    }
  },
  created() {
    // 绑定按键esc隐藏此插件事件
    document.addEventListener('keyup', e => {
      if (this.visible && (e.key === 'Escape' || e.keyCode === 27)) {
        this.off();
      }
    });
  }
};
</script>

<style lang="stylus" scoped>
$i_c = rgba(#000, 0.3)
$i_w = 42px
$i_h = 42px
$c_def = #008B8B
$c_succ = #4a7
$c_warn = #cc0
$c_error = #d10
$c_info = #07d
bs1(n) {
  box-shadow 0 1px 3px 0 rgba(#000, 0.12)
}
bs2(n) {
  box-shadow 0 2px 6px 0 rgba(#000, 0.18)
}
bs3(n) {
  box-shadow 0 1px 3px 0 rgba(#000, 0.23)
}
@keyframes vicp_progress {
  0% {
    background-position-y 0
  }
  100% {
    background-position-y 40px
  }
}
@keyframes vicp {
  0% {
    opacity 0
    transform scale(0) translatey(-60px)
  }
  100% {
    opacity 1
    transform scale(1) translatey(0)
  }
}
a {
  border none
}
.vue-image-crop-upload {
  .vicp-wrap {
    .vicp-step1 {
      .description {
        color #999
        padding-bottom 10px
        display block
      }
      .vicp-drop-area {
        position relative
        box-sizing border-box
        padding 35px
        height 170px
        background-color rgba(0, 0, 0, 0.03)
        text-align center
        border 1px dashed rgba(0, 0, 0, 0.08)
        overflow hidden
        // 上传图标
        .vicp-icon1 {
          display block
          margin 0 auto 6px
          width $i_w
          height $i_h
          overflow hidden
          .vicp-icon1-arrow {
            display block
            margin 0 auto
            width 0
            height 0
            border-bottom $i_h * 0.35 solid $i_c
            border-left $i_h * 0.35 solid transparent
            border-right $i_h * 0.35 solid transparent
          }
          .vicp-icon1-body {
            display block
            width $i_w * 0.3
            height $i_h * 0.35
            margin 0 auto
            background-color $i_c
          }
          .vicp-icon1-bottom {
            box-sizing border-box
            display block
            height $i_h * 0.3
            border 6px solid $i_c
            border-top none
          }
        }
        .vicp-hint {
          display block
          padding 15px
          font-size 14px
          color #666
          line-height 30px
        }
        .vicp-no-supported-hint {
          display block
          position absolute
          top 0
          left 0
          padding 30px
          width 100%
          height 60px
          line-height 30px
          background-color #eee
          text-align center
          color #666
          font-size 14px
        }
        &:hover {
          cursor pointer
          border-color rgba(0, 0, 0, 0.1)
          background-color rgba(0, 0, 0, 0.05)
        }
      }
    }
    .vicp-step2 {
      .vicp-crop {
        overflow hidden
        .vicp-crop-left {
          float left
          padding-left 10px
          .vicp-img-title {
            font-size 14px
            line-height 1
            padding-bottom 15px
            color #bbb
            display block
          }
          .vicp-img-container {
            position relative
            display block
            width 320px
            height 240px
            background-color #e5e5e0
            overflow hidden
            .vicp-img {
              position absolute
              display block
              cursor move
              user-select none
            }
            .vicp-img-shade {
              bs2 2px
              position absolute
              background-color rgba(#f1f2f3, 0.8)
              &.vicp-img-shade-1 {
                top 0
                left 0
              }
              &.vicp-img-shade-2 {
                bottom 0
                right 0
              }
            }
            .vicp-rotate {
              position absolute
              width 18px
              height 18px
              right 5px
              top 5px
              padding 5px
              cursor pointer
              i {
                display block
                text-align center
                width 18px
                height 18px
                border-radius 100%
                line-height 18px
                text-align center
                font-size 12px
                font-weight bold
                background-color rgba(#a51b1b, 0.9)
                color #fff
                overflow hidden
                &:first-child {
                  float left
                }
                &:last-child {
                  float right
                }
              }
              &:hover {
                background-color rgba(0, 0, 0, 0.3)
                i {
                  bs1 1px
                  background-color rgba(#a51b1b, 1)
                }
              }
            }
          }
          .vicp-range {
            position relative
            margin 30px 0 10px 0
            width 320px
            height 18px
            .vicp-icon5,
            .vicp-icon6 {
              position absolute
              top 0
              width 18px
              height 18px
              border-radius 100%
              background-color rgba(#a51b1b, 0.7)
              &:hover {
                bs1 1px
                cursor pointer
                background-color rgba(#a51b1b, 1)
              }
            }
            // 减号
            .vicp-icon5 {
              left 0
              &::before {
                position absolute
                content ''
                display block
                left 3px
                top 8px
                width 12px
                height 2px
                background-color #fff
              }
            }
            // 加号
            .vicp-icon6 {
              right 0
              &::before {
                position absolute
                content ''
                display block
                left 3px
                top 8px
                width 12px
                height 2px
                background-color #fff
              }
              &::after {
                position absolute
                content ''
                display block
                top 3px
                left 8px
                width 2px
                height 12px
                background-color #fff
              }
            }
            input[type=range] {
              display block
              padding-top 5px
              margin 0 auto
              width 260px
              height 8px
              vertical-align top
              background transparent
              appearance none
              cursor pointer
              &:focus {
                outline none
              }
              // 滑块
              &::-webkit-slider-thumb {
                bs2 2px
                appearance none
                margin-top -3px
                width 12px
                height 12px
                background-color lighten($c_def, 10)
                border-radius 100%
                border none
                transition 0.2s
              }
              &::-moz-range-thumb {
                bs2 2px
                appearance none
                width 12px
                height 12px
                background-color lighten($c_def, 10)
                border-radius 100%
                border none
                transition 0.2s
              }
              &::-ms-thumb {
                bs2 2px
                appearance none
                width 12px
                height 12px
                background-color lighten($c_def, 10)
                border none
                border-radius 100%
                transition 0.2s
              }
              &:active {
                &::-moz-range-thumb {
                  bs3 3px
                  width 14px
                  height 14px
                }
                &::-ms-thumb {
                  bs3 3px
                  width 14px
                  height 14px
                }
                &::-webkit-slider-thumb {
                  bs3 3px
                  margin-top -4px
                  width 14px
                  height 14px
                }
              }
              /* 轨道
              --------------------------------------------------------------- */
              &::-webkit-slider-runnable-track {
                bs1 1px
                width 100%
                height 6px
                cursor pointer
                border-radius 2px
                border none
                background-color rgba($c_def, 0.3)
              }
              &::-moz-range-track {
                bs1 1px
                width 100%
                height 6px
                cursor pointer
                border-radius 2px
                border none
                background-color rgba($c_def, 0.3)
              }
              &::-ms-track {
                bs1 1px
                width 100%
                cursor pointer
                background transparent
                border-color transparent
                color transparent
                height 6px
                border-radius 2px
                border none
              }
              &::-ms-fill-lower {
                background-color rgba($c_def, 0.3)
              }
              &::-ms-fill-upper {
                background-color rgba($c_def, 0.15)
              }
              &:focus {
                &::-webkit-slider-runnable-track {
                  background-color rgba($c_def, 0.5)
                }
                &::-moz-range-track {
                  background-color rgba($c_def, 0.5)
                }
                &::-ms-fill-lower {
                  background-color rgba($c_def, 0.45)
                }
                &::-ms-fill-upper {
                  background-color rgba($c_def, 0.25)
                }
              }
            }
          }
        }
        .vicp-crop-right {
          float right
          width 295px
          padding-right 10px
          .vicp-preview {
            &:after {
              content ''
              display block
              clear both
            }
            .vicp-preview-title {
              font-size 14px
              line-height 1
              padding-bottom 15px
              color #bbb
              display block
            }
            .vicp-preview-item {
              position relative
              float left
              &.i1 {
                margin-right 16px
              }
              .vicp-preview-img {
                margin 0 auto
                background-color #fff
                box-shadow 0 0 3px #CCC
                overflow hidden
                user-select none
                overflow hidden
                text-align center
                img {
                  width 100%
                  float left
                }
              }
            }
          }
        }
      }
    }
    .vicp-step3 {
      .vicp-upload {
        position relative
        box-sizing border-box
        padding 35px
        height 170px
        background-color rgba(0, 0, 0, 0.03)
        text-align center
        border 1px dashed #ddd
        .vicp-loading {
          display block
          padding 15px
          font-size 16px
          color #999
          line-height 30px
        }
        .vicp-progress-wrap {
          margin-top 12px
          background-color rgba(#000, 0.08)
          border-radius 3px
          .vicp-progress {
            position relative
            display block
            height 5px
            border-radius 3px
            background-color $c_succ
            box-shadow 0 2px 6px 0 rgba($c_succ, 0.3)
            transition width 0.15s linear
            background-image linear-gradient(-45deg, rgba(#fff, 0.2) 25%, transparent 25%, transparent 50%, rgba(#fff, 0.2) 50%, rgba(#fff, 0.2) 75%, transparent 75%, transparent)
            background-size 40px 40px
            animation vicp_progress 0.5s linear infinite
            &::after {
              content ''
              position absolute
              display block
              top -3px
              right -3px
              width 9px
              height 9px
              border 1px solid rgba(#f5f6f7, 0.7)
              box-shadow 0 1px 4px 0 rgba($c_succ, 0.7)
              border-radius 100%
              background-color $c_succ
            }
          }
        }
        .vicp-error,
        .vicp-success {
          height 100px
          line-height 100px
        }
      }
    }
    .vicp-error,
    .vicp-success {
      display block
      font-size 14px
      line-height 24px
      height 24px
      color $c_error
      text-align center
      vertical-align top
    }
    .vicp-success {
      color $c_succ
    }
    // 成功图标
    .vicp-icon3 {
      position relative
      display inline-block
      width 20px
      height 20px
      top 4px
      &::after {
        position absolute
        top 3px
        left 6px
        width 6px
        height 10px
        border-width 0 2px 2px 0
        border-color $c_succ
        border-style solid
        transform rotate(45deg)
        content ''
      }
    }
    // 错误图标
    .vicp-icon2 {
      position relative
      display inline-block
      width 20px
      height 20px
      top 4px
      &::after,
      &::before {
        content ''
        position absolute
        top 9px
        left 4px
        width 13px
        height 2px
        background-color $c_error
        transform rotate(45deg)
      }
      &::after {
        transform rotate(-45deg)
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/common/component/avatarEditor.vue